import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import Layout from "../../../components/layout/Layout";
import "../../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../../assets/InnerCSS/css/styles.css";
import "../../../assets/InnerCSS/css/custom.css";
import CandidatePasswordComponent from "../../../components/admin/candidate/candidate-password/CandidatePasswordComponent";
import IdNameModel from "../../../models/common/IdNameModel";
import masterDataService from "../../../services/master-data-service";
import toasterUtils from "../../../utils/toaster-utils";
import modalUtils from "../../../utils/modal-utils";
import { useHistory } from "react-router";

const CandidatePassword = () => {
    const history = useHistory();
    const [roleList, setRoleList] = useState<IdNameModel[]>([]);
    const [refreshRoles, setRefreshRoles] = useState<number>(2);

    useEffect(() => {
        fillRoles();
    }, []);

    const fillRoles = () => {
        setRefreshRoles(2);
        modalUtils.showLoader();
        masterDataService.loadRoles().then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setRoleList(res.items);
            setRefreshRoles(refreshRoles * 5);
        }).catch((error) => {
            setRefreshRoles(refreshRoles * 5);
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Passwords
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> Password Search </h4>
            </div>
            {refreshRoles > 2 &&
                <CandidatePasswordComponent roleList={roleList} />
            }
        </Layout>
    );
};
export default CandidatePassword;